var render = function render(){var _vm=this,_c=_vm._self._c;return _c('keep-alive',[(_vm.component)?_c(_vm.component,{tag:"component",attrs:{"accessKey":_vm.accessKey},on:{"dataInput":_vm.onInput,"compSignal":_vm.processCompSignal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }